import { Job } from './jobs';

export interface ModalState {
  name: ModalName;
  data: any;
}

export enum ModalName {
  DuplicateJob = 'duplicateJob',
  EditJob = 'editJob',
  ReassignJob = 'reassignJob',
  ViewJobImages = 'viewJobImages',
  Confirmation = 'confirmation',
  OrgHierarchy = 'orgHierarchy',
  EditOrg = 'editOrg',
  ViewChat = 'viewChat',
}

export interface EditJobDataBag {
  job: Job;
}

export interface ReassignJobDataBag {
  jobs: Job[];
}

export interface ViewJobImagesDataBag {
  job: Job;
}

export interface ConfirmationDataBag {
  title: string;
  message: string;
  confirmAction: () => void;
}
